<template>
  <div
    ref="wagonElement"
    class="wagon"
    :class="positioningClass"
    :style="`top:${offset}px`"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  props: {
    topLimitId: {
      type: String,
      default: '',
    },
    bottomLimitId: {
      type: String,
      default: '',
    },
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      positioningClass: 'wagon-top',
      topLimitElement: null as HTMLElement | null,
      bottomLimitElement: null as HTMLElement | null,
      viewportWidth: 0,
    }
  },
  async mounted() {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onWindowResize)

    await Vue.nextTick()
    this.topLimitElement = document.getElementById(this.topLimitId)
    this.bottomLimitElement = document.getElementById(this.bottomLimitId)
    this.updateViewportWidth()
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    onWindowResize() {
      this.updateViewportWidth()
      this.onScroll()
    },
    onScroll() {
      if (this.viewportWidth >= 1280 && this.topLimitElement && this.bottomLimitElement) {
        if (this.topLimitElement.getBoundingClientRect().height <= 0) return
        if ((this.topLimitElement.getBoundingClientRect().top - this.offset) < 0) {
          this.positioningClass = 'wagon-moving'

          if ((this.bottomLimitElement.getBoundingClientRect().bottom
              - (this.$refs.wagonElement as HTMLElement).offsetHeight
              - this.offset) < 0) {
            this.positioningClass = 'wagon-bottom'
          }
        } else {
          this.positioningClass = 'wagon-top'
        }
      }
    },
    updateViewportWidth() {
      this.viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    },
  },
})
</script>

<style lang="scss">
@screen xl {
  .wagon {
    @apply self-start;
  }

  .wagon-moving {
    @apply fixed;
  }

  .wagon-bottom {
    @apply mt-auto;
  }
}
</style>
